<template>
  <div class="jc-center">
    <div class="content">
      <h1>近期动态</h1>
      <div class="flex">
        <div class="box-content">
          <div class="flex jc-sb mb30">
            <div class="fz20">公司新闻</div>
            <div class="fz12 cp">更多 »</div>
          </div>
          <a v-for="(item, index) in list1" :key="index" class="mb20 flex cp">
            <img :src="item.schoolPageInfo.poster" />
            <div>
              <div class="fz16 mb10 color-gray-10 bolder ellipsis ta-left">
                {{ item.schoolPageInfo.title }}
              </div>
              <div class="color-gray-7 fz14 ta-left">
                {{ item.schoolPageInfo.content }}
              </div>
            </div>
          </a>
        </div>
        <div class="box-content">
          <div class="flex jc-sb mb30">
            <div class="fz20">行业动态</div>
            <div class="fz12 cp">更多 »</div>
          </div>
          <a
            v-for="(item, index) in list2"
            :key="index"
            class="flex cp dynamic jc-sb"
          >
            <div class="left ellipsis color-gray-10 fz16 ta-left">
              {{ item.schoolPageInfo.title }}
            </div>
            <div class="fz14 color-gray-7">
              {{
                item.schoolPageInfo.createTime
                  ? item.schoolPageInfo.createTime.split(" ")[0]
                  : ""
              }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
      list1: [],
      list2: [],
    };
  },
  watch: {
    info: {
      handler() {
        this.initList();
      },
      deep: true,
    },
  },
  methods: {
    initList() {
      this.list = this.info.wxSchoolPageItemList;
      let list1 = this.info.wxSchoolPageItemList.slice(0, 4);
      let list2 = this.info.wxSchoolPageItemList.slice(
        4,
        this.info.wxSchoolPageItemList.length
      );
      let arr1 = [];
      let arr2 = [];
      list1.forEach((item) => {
        if (item.isEmpty != "1") {
          if (item.schoolPageInfo.content) {
            item.schoolPageInfo.content = item.schoolPageInfo.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
          arr1 = arr1.concat(item);
        }
      });
      list2.forEach((item) => {
        if (item.isEmpty != "1") {
          if (item.schoolPageInfo.content) {
            item.schoolPageInfo.content = item.schoolPageInfo.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
          arr2 = arr2.concat(item);
        }
      });
      this.list1 = arr1;
      this.list2 = arr2;
    },
  },
  mounted() {
    this.initList();
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  padding: 48px 0;
  text-align: center;
  h1 {
    font-size: 36px;
  }
  .box-content {
    width: 580px;
    padding: 20px 20px 10px 20px;
    margin: 0 10px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    height: 566px;
  }
  .more {
    color: #8c8c8c;
  }
  img {
    width: 160px;
    height: 100px;
    margin-right: 20px;
  }
  .color-gray-7 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .dynamic {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
    .left {
      text-align: left;
      width: 400px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/propaganda/propaganda2/index.vue